module.exports = __webpack_public_path__ + "img/3화_20(2).f313aa58.jpg";